<template>
    <div>
        <div class="mb-3">
            <div v-if="selected_regulation_version_details" class="d-flex flex-row">
                <h5 class="">Checks for:</h5>
                <h5 class="font-weight-light ml-2">{{ selected_regulation_version_details.name }}</h5>
            </div>
            <b-button @click="handleModal" variant="primary" type="button" class="btn btn-primary mt-1" size="sm">
                <i class="mdi mdi-plus mr-1"> </i> Create
            </b-button>
        </div>
        <webix-ui :config="ui" v-model="checks_by_regulation_version"></webix-ui>
        <div id="checksTablePaging"></div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import { certificateValidationComputed, certificateValidationMethods } from "../../../state/helpers";
//eslint-disable-next-line

export default {
    data: () => ({
        hasMounted: false,
        checks_data: [
            { id: "1", active: "1", question: "Expiry Date" },
            { id: "2", active: "0", question: "Agency valid" },
            { id: "3", active: "1", question: "Reg no. valid" },
            { id: "4", active: "0", question: "Stamp correct" },
        ],
    }),
    computed: {
        ...certificateValidationComputed,
        ui() {
            //eslint-disable-next-line
            let el = this;

            let ui = {
                id: "checksTable",
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border datatableHover",
                autoheight: true,
                // hover: "datatableHover",
                // select: "cell",
                hover: "checksTableHoverRow",
                minHeight: 50,
                minColumnWidth: 120,
                rowHeight: 30,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                // select: true,
                // editable: true,
                select: true,
                pager: {
                    template: "{common.prev()} {common.pages()} {common.next()}",
                    container: "checksTablePaging",
                    css: { width: "100% !important" },
                    size: 15,
                    group: 5,
                },
                columns: [
                    // TODO: Delete
                    {
                        id: "assigned",
                        header: { text: "Set Active", css: { "text-align": "center" } },
                        css: { "text-align": "center" },
                        template: function(obj) {
                            //eslint-disable-next-line
                            console.log("ASigned", obj);
                            if (obj.assigned == 1) {
                                return `<div class="on_collect"><i class="mdi mdi-checkbox-marked-outline bx-sm non-active_switch"></i> </div>`;
                            }

                            if (obj.assigned == 0) {
                                return `<div class="on_collect"> <i class="mdi mdi-checkbox-blank-outline bx-sm active_switch"></i> </div>`;
                            }
                        },
                    },
                    {
                        id: "prompt",
                        header: ["Check"],
                        tooltip: false,
                        fillspace: 1,
                        // width: 300,
                    },
                ],
                ready() {},
                on: {
                    onBeforeSelect(id) {
                        //eslint-disable-next-line
                        let item = this.getItem(id);
                        //eslint-disable-next-line
                        let el = this.$scope.$parent;
                        //eslint-disable-next-line
                        console.log("I was clciked", item);

                        el.setSelectedCheckDetails(item);

                        el.setCheckOptions({ check_id: item.id });
                        // el.hanldeEmit("value", item);
                        // el.$emit("selectedRegulationVersion", item);
                        // el.s;
                        // el.setSelectedRegulationVersionDetails(item);
                        // el.setValidationChecksByRegulationVersion({ regulation_version_id: item.id });
                    },
                },
                onChange: {},
                onClick: {
                    on_collect: function(event, id) {
                        let item = this.getItem(id);

                        //eslint-disable-next-line
                        let el = this.$scope.$parent;

                        //eslint-disable-next-line
                        console.log("is this workinggggg", item);

                        el.handleSwal(item);
                    },
                },
            };
            //
            return ui;
        },
    },
    methods: {
        ...certificateValidationMethods,
        handleSwal(item) {
            let table = window.webix.$$("checksTable");
            // this.show = true;
            if (item.assigned == 0) {
                Swal.fire({
                    title: `Add the following check:`,
                    text: `"${item.prompt}"`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Confirm",
                }).then((result) => {
                    if (result.value) {
                        item.assigned = 1;

                        // this.addClientToCollectionList({ collection_clients: [item.id], single_client: true }).then(() => {
                        //     Swal.fire(`${item.name} was added to the collection list`, "", "success");
                        table.updateItem(item.id, item);
                        //     //refreshes the table on the screen
                        //     this.setClients().then(() => {
                        //         this.loadTableStateFromLocalStorage();
                        //         // this.show = false;
                        //     });
                        // });

                        //eslint-disable-next-line
                        // console.log("IT was set to 1");
                        this.saveSetRegulationCheck({
                            regulation_version_id: this.selected_regulation_version_details.id,
                            check_id: item.id,
                            checked: 1,
                        }).then(() => {
                            //eslint-disable-next-line
                            console.log("IT was set to 0");
                        });
                    } else {
                        //else just set it back to the state it was
                        item.assigned = 0;
                        //row id and the obejct to update with
                        table.updateItem(item.id, item);
                        // this.loadTableStateFromLocalStorage();
                        // this.show = false;
                    }
                });
            }

            if (item.assigned == 1) {
                Swal.fire({
                    title: `Remove the following check:`,
                    text: `"${item.prompt}"`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Confirm",
                }).then((result) => {
                    if (result.value) {
                        item.assigned = 0;

                        // this.deleteCollectionListRecord({ client_id: item.id }).then(() => {
                        //     Swal.fire(`${item.name} was removed from the collection list`, "", "success");

                        table.updateItem(item.id, item);
                        //     //refreshes the table on the screen
                        //     this.setClients().then(() => {
                        //         this.loadTableStateFromLocalStorage();
                        //         // this.show = false;
                        //     });
                        // });

                        //eslint-disable-next-line
                        // console.log("selected", this.selected_regulation_version_details.id, item.id);

                        this.saveSetRegulationCheck({
                            regulation_version_id: this.selected_regulation_version_details.id,
                            check_id: item.id,
                            checked: 0,
                        }).then(() => {
                            //eslint-disable-next-line
                            // console.log("IT was set to 0");
                        });
                    } else {
                        item.active = 1;
                        table.updateItem(item.id, item);
                        // this.loadTableStateFromLocalStorage();
                        // this.show = false;
                    }
                });
            }
        },
        handleModal() {
            this.$emit("handleModal", "createCheckModal");
        },
    },
    watch: {
        //eslint-disable-next-line
        checks_by_regulation_version(oldVal) {
            //eslint-disable-next-line
            console.log("overhere ");
            //eslint-disable-next-line
            const table = window.webix.$$("checksTable");
            //eslint-disable-next-line
            let selectedId = !!table.getSelectedId(); // typecast undefined to false
            let getFirstId = oldVal[0].id; // ! this will be the first row in the table
            // let getFirstId = oldVal[1].id;
            // let getFirstId

            // table.setFocus(1);

            //eslint-disable-next-line
            // console.log("checking", getFirstId);

            // if (selectedId == false) {
            setTimeout(() => {
                table.select(getFirstId);
            }, 100);
            // }
        },
    },
    mounted() {
        // NB I think is is suposed to set the active regulation you must first query the regulation version though and pass that instead of hard coding
        // if (this.hasMounted == false) {
        //     this.setValidationChecksByRegulationVersion({ regulation_version_id: 3 }).then(() => {
        //         //eslint-disable-next-line
        //         console.log("the validation checks", this.checks_by_regulation_version);
        //         //sets this for the first load
        //         this.setSelectedRegulationVersionDetails(this.regulation_versions[2]); // for headings only
        //         //eslint-disable-next-line
        //         console.log("regulation version details", this.selected_regulation_version_details);
        //     });
        // }
        // window.$$webix.select()
    },
};
</script>

<style lang="scss">
.active_switch {
    // color: darken(#28a745, 10%);
    cursor: pointer;
}
.non-active_switch {
    cursor: pointer;
}
.checksTableHoverRow {
    background: #f0dcb6;
    cursor: pointer;
}
</style>
